module.exports = __webpack_public_path__ + "static/media/cherry-3.6699ccd9.png";